<template>
  <component :is="currentComponent" v-bind="currentProperties"/>
</template>

<script>
import UploadRebateListLander from './UploadRebateListLander.vue';
import ApproveRebateAmount from './ApproveRebateAmount.vue';
import NothingToDo from './NothingToDo.vue';
import statusConstants from '@/json/statusConstants.json'

export default {
  data() {
    return {
      // NOTE: Default component is set to UploadRebateListLander
      currentComponent: '',
      currentProperties: ''
    };
  },
  components: {
    UploadRebateListLander,
    ApproveRebateAmount,
    NothingToDo,
  },
  mounted() {
    this.$nextTick(() => {
      this.setComponentInCurrentCycle();
    })

    this.$root.$on('switchComponentInCurrentCycle', (status) => {
      //update status and then change component
      localStorage.setItem('clientRebateStatus', status);
      this.$store.dispatch('setClientRebateStatus', localStorage.getItem('clientRebateStatus'));
      this.setComponentInCurrentCycle();
    })
  },
  methods: {
    // NOTE: Switch components based on partner status
    setComponentInCurrentCycle() {
      switch(localStorage.getItem('clientRebateStatus')) {
        case statusConstants['Scheduled']: {
          this.currentComponent = 'NothingToDo';
          this.currentProperties = {
            status: 'List Scheduled'
          }
          break;
        }

        case statusConstants['Email Sent']: {
          this.currentComponent = 'UploadRebateListLander';
          this.currentProperties = {
            status: 'Email Sent'
          }
          break;
        }
  
        case statusConstants['List Received']: {
          this.currentComponent = 'NothingToDo';
          this.currentProperties = {
            status: 'List Received'
          }
          break;
        }

        case statusConstants['Rebates Calculated']: {
          this.currentComponent = 'NothingToDo';
          this.currentProperties = {
            status: 'Rebates Calculated'
          }
          break;
        }

        case statusConstants['Approved by Partner']: {
          this.currentComponent = 'ApproveRebateAmount'
          this.currentProperties = {
            status: 'Approved by Partner'
          }
          break;
        }

        case statusConstants['Rejected by Partner']: {
          this.currentComponent = 'ApproveRebateAmount'
          this.currentProperties = {
            status: 'Rejected by Partner'
          }
          break;
        }

        case statusConstants['Approved by Radix']: {
          this.currentComponent = 'ApproveRebateAmount'
          this.currentProperties = {
            status: 'Approved by Radix'
          }
          break;
        }

        case statusConstants['Rejected by Radix']: {
          this.currentComponent = 'ApproveRebateAmount'
          this.currentProperties = {
            status: 'Rejected by Radix'
          }
          break;
        }

        case statusConstants['Invoice Received']: {
          this.currentComponent = 'ApproveRebateAmount'
          this.currentProperties = {
            status: 'Invoice Received'
          }
          break;
        }

        case statusConstants['Invoice Approved']: {
          this.currentComponent = 'ApproveRebateAmount'
          this.currentProperties = {
            status: 'Invoice Approved'
          }
          break;
        }

        case statusConstants['Invoice Rejected']: {
          this.currentComponent = 'ApproveRebateAmount'
          this.currentProperties = {
            status: 'Invoice Rejected'
          }
          break;
        }
  
        case statusConstants['Payment Queued']: {
          this.currentComponent = 'NothingToDo'
          this.currentProperties = {
            status: 'Payment Queued'
          }
          break;
        }

        case statusConstants['Paid']: {
          this.currentComponent = 'NothingToDo';
          this.currentProperties = {
            status: 'Paid'
          }
          break;
        }
  
        default: {
          this.currentComponent = 'NothingToDo';
          this.currentProperties = {
            status: 'Scheduled'
          }
          break;
        }
      }
    }
  },
  destroyed() {
    this.$root.$off('switchComponentInCurrentCycle');
  }
};
</script>
